import { useNavigate } from "react-router-dom";
import Background from "./Background";
import ProgressBar from "./ProgressBar";
import TopBar from "./TopBar";

export default function StepShell({ step, totalSteps, title, showBack=true, children }) {
  const navigate = useNavigate();
  
  return (
    <Background>
      <div className="px-4 py-8 sm:py-10">
        <TopBar showBack={showBack} title={title} />
        <div className="mt-4">
          <ProgressBar current={step} total={totalSteps} />
        </div>
        <div className="mt-6">{children}</div>
        <div className="mt-8 text-center text-xs text-gray-500">
          By continuing you agree to our{" "}
          <button 
            onClick={() => navigate("/terms")} 
            className="text-orange-600 hover:underline"
          >
            Terms of Use
          </button>
          {" "}&amp;{" "}
          <button 
            onClick={() => navigate("/privacy")} 
            className="text-orange-600 hover:underline"
          >
            Privacy Policy
          </button>.
        </div>
      </div>
    </Background>
  );
}
